import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@msrbusiness.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back, admin");
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-msr-surface" data-testid="admin-login-page">
      <div className="hidden lg:flex relative bg-msr-ink text-white p-12 flex-col justify-between overflow-hidden">
        <div className="absolute -top-24 -left-24 h-96 w-96 border-2 border-msr-blue/30 rotate-12" aria-hidden />
        <div className="absolute -bottom-24 -right-24 h-72 w-72 border-2 border-msr-green/30 -rotate-12" aria-hidden />
        <div className="relative">
          <Link to="/" className="inline-flex items-center bg-white p-3">
            <img src="/brand/msr-logo.png" alt="MSR Business Solutions" className="h-12 w-auto object-contain" />
          </Link>
        </div>
        <div className="relative space-y-4">
          <div className="overline text-msr-green-light">Manage MSR</div>
          <h1 className="font-heading font-extrabold text-4xl lg:text-5xl tracking-tight max-w-md">
            Run solutions, products, orders, and leads from one console.
          </h1>
          <p className="text-white/70 max-w-md leading-relaxed">Sign in with your admin account to manage homepage content, solutions, products, categories, images, demo URLs, and customer inquiries.</p>
        </div>
        <div className="relative text-xs text-white/40">© {new Date().getFullYear()} MSR Business Solutions Corp.</div>
      </div>
      <div className="flex items-center justify-center p-6 lg:p-12">
        <form onSubmit={handle} className="w-full max-w-md space-y-5 bg-white border border-msr-line p-8" data-testid="admin-login-form">
          <div>
            <div className="overline mb-2">Admin Login</div>
            <h2 className="font-heading font-extrabold text-3xl">Welcome back</h2>
            <p className="text-sm text-msr-slate mt-1">Sign in to your MSR admin account.</p>
          </div>
          <label className="block text-xs font-semibold uppercase tracking-wider text-msr-slate">
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1 block w-full border border-msr-line px-3 py-2.5 text-sm text-msr-ink font-normal normal-case tracking-normal focus:outline-none focus:border-msr-blue" data-testid="admin-login-email" />
          </label>
          <label className="block text-xs font-semibold uppercase tracking-wider text-msr-slate">
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 block w-full border border-msr-line px-3 py-2.5 text-sm text-msr-ink font-normal normal-case tracking-normal focus:outline-none focus:border-msr-blue" data-testid="admin-login-password" />
          </label>
          <button type="submit" disabled={submitting} className="w-full btn-msr-primary disabled:opacity-60" data-testid="admin-login-submit-btn">
            {submitting ? "Signing in..." : "Sign In"}
          </button>
          <Link to="/" className="block text-xs text-center text-msr-slate hover:text-msr-blue" data-testid="admin-login-back-link">
            ← Back to public site
          </Link>
        </form>
      </div>
    </div>
  );
}
